export default {"src":"/_next/static/media/pay.d8cc73fb.svg","height":25,"width":25};